import { Button, Tooltip } from "@mui/material";

// Per-tone visual overrides. "default" keeps the original blue-tinted look;
// "neutral" is a plain white button with a hairline grey border + grey text.
const TONE_STYLES = {
  default: {
    borderColor: "#1799b522",
    backgroundColor: "#1799b50d",
    "&:hover": {
      backgroundColor: "#EEEDFE",
      borderColor: "#1799b5",
    },
  },
  neutral: {
    color: "#3f3f46",
    borderColor: "rgba(0, 0, 0, 0.18)",
    backgroundColor: "none",
    // backgroundColor: "#ffffff",
    svg: { color: "#52525b" },
    "&:hover": {
      backgroundColor: "#f6f6f4",
      borderColor: "rgba(0, 0, 0, 0.32)",
    },
  },
};

const QuickActionButton = ({
  startIcon,
  tooltip,
  children,
  onClick,
  disabled,
  tone = "default",
}) => {
  const toneStyles = TONE_STYLES[tone] || TONE_STYLES.default;
  const btn = (
    <Button
      size="medium"
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      startIcon={startIcon}
      sx={{
        px: 1.5,
        py: 0.75,
        flexShrink: 1,
        flexGrow: 0,
        background: "none",
        // flexGrow: 1,
        minWidth: "unset",
        borderRadius: "8px",
        fontSize: "11px",
        fontWeight: 500,
        textTransform: "none",
        svg: {
          fontSize: "15px !important",
        },
        "&.Mui-disabled": {
          backgroundColor: "#F5F4EF",
          borderColor: "#E0DFD8",
          color: "#B4B2A9",
          svg: {
            color: "#B4B2A9",
          },
        },
        ...toneStyles,
      }}
    >
      {children}
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {btn}
      </Tooltip>
    );
  }

  return btn;
};

export default QuickActionButton;
// import { Button, Tooltip } from "@mui/material";

// const QuickActionButton = ({
//   startIcon,
//   tooltip,
//   children,
//   onClick,
//   disabled,
// }) => {
//   return (
//     <Button
//       size="medium"
//       // size="large"
//       variant="outlined"
//       disabled={disabled}
//       // color="inherit"
//       onClick={onClick}
//       startIcon={startIcon}
//       sx={{
//         // justifyContent: "flex-start",
//         // textTransform: "none",
//         px: 1,
//         flexShrink: 1,
//         flexGrow: 1,
//         minWidth: "unset",
//         borderRadius: "12px",
//         fontSize: "11px",
//         // fontSize: "12px",
//         svg: {
//           fontSize: "16px !important",
//         },
//         // color: grey[700],
//         // borderColor: grey[300],
//       }}
//     >
//       {children}
//     </Button>
//   );
// };

// export default QuickActionButton;
